<template>
  <!-- <div style="height: 90vh;"> -->
    <div id="image-container" 
      @mousedown="startDrag"
      @mouseup="stopDrag"
      @mouseleave="stopDrag"
      @mousemove="drag"
      @wheel="handleWheel"
       ref="container"
        :style="{ 
          cursor: isDragging ? 'grabbing' : 'grab',
          transform: `translate(calc(-50% + ${offsetX}px), calc(-50% + ${offsetY}px)) scale(${scale})`,
          transformOrigin: 'center center'
        }"
    >
    <span class="close" @click.stop="closeDialog" @mousedown.stop>x</span>
      <img :src="imgSrc"
        ref="image"
      />
      <!-- @click="toggleZoom"  点击放大-->
    </div>
</template>
<script>
// import testImg from './testImg.jpeg'; // 导入图片
 
export default {
  name: 'DialogPic',
  props: {
    // 图片路径
    imgSrc: {
      type: String,
      default:'', // 没有传值时使用默认图片
    }
  },
  data () {
    return {
      scale: 1, // 初始缩放比例
      isDragging: false, // 是否正在拖拽
      startX: 0, // 拖拽开始时的鼠标 X 坐标
      startY: 0, // 拖拽开始时的鼠标 Y 坐标
      offsetX: 0, // 图片的 X 偏移量
      offsetY: 0, // 图片的 Y 偏移量
    };
  },
  mounted () {
    // 图片加载完成后居中
    this.$refs.image.onload = () => {
      this.offsetX = 0;
      this.offsetY = 0;
    };
  },
  methods: {
    closeDialog () {
        this.$emit('close');
    },
 
    // 鼠标按下事件 - 开始拖拽
    startDrag (event) {
      this.isDragging = true; // 开始拖拽
      this.startX = event.clientX - this.offsetX; // 记录起始位置
      this.startY = event.clientY - this.offsetY;
    },
 
    // 鼠标抬起事件 - 停止拖拽
    stopDrag () {
      this.isDragging = false; // 停止拖拽
    },
 
    // 鼠标移动事件 - 拖拽图片
    drag (event) {
      if (this.isDragging) { // 如果正在拖拽
        event.preventDefault();
        this.offsetX = event.clientX - this.startX; // 更新偏移量
        this.offsetY = event.clientY - this.startY;
      }
    },
 
    // 鼠标滚轮事件 - 缩放图片
    handleWheel (event) {
      event.preventDefault(); // 阻止默认的滚动行为
      
      // 计算新的缩放比例
      const delta = event.deltaY > 0 ? -0.1 : 0.1;
      const newScale = Math.max(0.5, Math.min(5, this.scale + delta)); // 限制缩放范围 0.5-5
      
      this.scale = newScale;
    },
  },
};
</script>
<style scoped>
#image-container {
  position: fixed;
  z-index: 999;
  cursor: grab;
  top: 50%;
  left: 50%;
  transform-origin: center center;
  max-width: 80vw;
  max-height: 80vh;
}

#image-container img{
  max-width: 80vw;
  max-height: 80vh;
  object-fit: contain;
  user-select: none;
  pointer-events: none; /* 防止图片本身的拖拽 */
}

.close{
  position: absolute;
  z-index: 9999;
  top: 5px;
  right: 5px;
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
  color: white;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
</style>

